import { StyleSheet, Text, View, Image, ActivityIndicator, Modal, ScrollView, FlatList, PixelRatio, Dimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import useAuth from '../../hooks/useAuth'
import Colours from '../../utils/Colours'
import { TouchableOpacity } from 'react-native'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import { Picker } from '@react-native-picker/picker'
import BankList from './BankList'
import Toast from 'react-native-toast-message'
import toastConfig from '../../toasts/toastConfig'
import VerifiedCustomer from './VerifiedCustomer'
import socketConfig from '../../utils/socketConfig'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import NoticeAlertComp from '../../alertComp/NoticeAlertComp'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const CustomerVerificationScreen = ({
    showVerifiedCustomer,
    setShowVerifiedCustomer,
    setShowCustomerVerificationScreen,
    hideWalletScreen,
    setHasDva,

}) => {
    const { phonenumber, email, image, sub, isVerifiedForPayment } = useAuth()
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading1, setIsLoading1] = useState(false)



    const [isFormContainerClickedA, setIsFormContainerClickedA] = useState(false)
    const [isFormContainerClickedB, setIsFormContainerClickedB] = useState(false)
    const [isFormContainerClickedBAN, setIsFormContainerClickedBAN] = useState(false)

    const [crossCheckNotice, setShowCrossCheckNotice] = useState(false)
    const [noticeMessage, setNoticeMessage] = useState('')

    const [showPickerItems, setShowPickerItems] = useState(false)
    const [isVisible, setIsVisible] = useState(false)//update
    const [account_name, setAccount_name] = useState()

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [accountNumber, setAccountNumber] = useState('')
    const [bvn, setBvn] = useState('')
    const [selectedBankName, setSelectedBankName] = useState('')
    const [selectedBankCode, setSelectedBankCode] = useState('')
    const [bankData, setBankData] = useState([])

    //For Web Socket
    // const [showVerifiedCustomer, setShowVerifiedCustomer] = useState(false)
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [startPolling, setStartPolling] = useState(false);


    const MAX_ATTEMPTS = 15; // Set a maximum number of polling attempts



    // const [isConnected, setIsConnected] = useState(false)

    const axiosPrivate = useAxiosPrivate()


    useEffect(() => {

        const userID = sub
        // Connect to the WebSocket server for Customer verification
        const socket = new WebSocket(socketConfig.WEBSOCKET_URL)
        //console.log('userIDsub', sub)

        // Event listener for successful connection
        socket.onopen = () => {
            //console.log('WebSocket connected')
            //setIsConnected(true)
            socket.send(JSON.stringify({ type: 'identify', userID: userID }))
        }

        // Event listener for receiving messages
        socket.onmessage = (event) => {
            //console.log('We are here now!!!!....')
            const message = JSON.parse(event.data)
            //console.log('Message from server:', message)
            //console.log('Email from Message Server:', message?.email)
            //console.log('UserID from Message Server:', message?.userID)


            //if (message.email === email) {
            if (message.userID === userID) {
                setIsLoading(false)

                if (message.isVerifiedForPayment) {
                    // Toast.show({
                    //     type: 'success',
                    //     text1: 'Success',
                    //     text2: 'Verification successful!',
                    //     visibilityTime: 6000,
                    // });
                    // setShowVerifiedCustomer(true)
                    setSuccessMessage('Verification successful!')
                    setIsSuccessCompVisible(true)

                } else {
                    // Toast.show({
                    //     type: 'error',
                    //     text1: 'Verification failed',
                    //     text2: `${message.reason}`,
                    // });
                    //console.log('messageReason', message.reason)
                    setErrorMessage(`Verification failed: ${message.reason}`);
                    setIsErrorCompVisible(true)
                }
            } else {
                //console.log('Message not relevant to current user.');
                setIsLoading(false)
                // Toast.show({
                //     type: 'error',
                //     text1: 'Data Error!',
                //     text2: `${message.reason}`,
                // });
                setErrorMessage(`Data Error: ${message.reason}`);
                setIsErrorCompVisible(true)
            }
        }

        // Event listener for connection close
        socket.onclose = () => {
            //console.log('WebSocket disconnected')
            setIsConnected(false)
        }

        // Event listener for errors
        socket.onerror = (error) => {
            //console.error('WebSocket error:', error)
            setErrorMessage('Connection error')
            setIsErrorCompVisible(true)
        }

        // Clean up when component unmounts
        return () => {
            socket.close();
            socket.onopen = null;
            socket.onclose = null;
            socket.onerror = null;
        }
    }, [sub])

    useEffect(() => {
        let pollingInterval;
        let attempts = 0;

        const checkVerificationStatus = async () => {
            try {
                //console.log(`POLLING: Attempt ${attempts + 1} of ${MAX_ATTEMPTS}...`);
                // Replace with your actual API endpoint
                const response = await axiosPrivate.get('/isVerifiedForPayments/isVerifiedForPayments');

                //console.log('POOLING RESP', response.data)

                const { isVerifiedForPayment } = response.data;

                if (isVerifiedForPayment) {
                    // If verification is successful, clear the polling interval
                    clearInterval(pollingInterval);
                    setIsLoading(false);
                    setStartPolling(false)
                    setSuccessMessage('Verification successful!');
                    setIsSuccessCompVisible(true);
                } else {
                    // Keep polling if verification is still false
                    //console.log('Verification still pending...');
                    attempts++;
                    if (attempts >= MAX_ATTEMPTS) {
                        // Stop polling if max attempts are reached
                        //console.warn('POLLING: Max attempts reached. Stopping polling.');
                        clearInterval(pollingInterval);
                        setStartPolling(false);
                        setIsLoading(false);
                        setErrorMessage('Verification timed out. Please try again later.');
                        setIsErrorCompVisible(true);
                    }
                }
            } catch (error) {
                //console.error('Error fetching verification status:', error);
                clearInterval(pollingInterval);
                setIsLoading(false);
                setStartPolling(false)
                setErrorMessage('Failed to check verification status.');
                setIsErrorCompVisible(true);
            }
        };

        // // Set the polling interval (e.g., every 5 seconds)
        // pollingInterval = setInterval(checkVerificationStatus, 5000);

        // Start polling only if the 'startPolling' state is true
        if (startPolling) {
            // Poll every 5 seconds
            pollingInterval = setInterval(checkVerificationStatus, 5000);
        }


        // Clean up the interval when the component unmounts
        return () => clearInterval(pollingInterval);
    }, [startPolling]);

    useEffect(() => {
        if (isVisible && account_name) {
            const nameParts = account_name.trim().split(/\s+/);
            if (nameParts.length > 0) {
                setFirstName(nameParts[0]);
                setLastName(nameParts[1] || ''); // fallback in case there's only one name
            }
        }
    }, [isVisible, account_name]);

    const handleAccountNumber = (text) => {
        setAccountNumber(text)
    }
    const handleBVN = (text) => {
        setBvn(text)
    }

    //  const hideScreen = () => setShowVerifiedCustomer(false)

    // const hideScreen = () => {
    //     //console.log('hideScreen called in ParentComponent'); // Debugging
    //     setShowVerifiedCustomer(false);
    // };

    // //console.log('Passing hideScreen to VerifiedCustomer:', hideScreen);

    const verifyIdentification = async () => {
        setIsLoading(true)
        setStartPolling(true)
        try {
            const response = await axiosPrivate.post('/createDVA/verifyBVN', {
                email,
                accountNumber,
                bvn,
                bankCode: selectedBankCode,
                //bankCode: '007',
                firstName,
                lastName,
            });
            // //console.log('Customer identification verified:', response.data.data);
        } catch (error) {
            setIsLoading(false)
            if (error.response) {
                ////console.error('Error from server:', error.response.data);
                // Toast.show({
                //     type: 'error',
                //     text1: 'Verificaiton Error',
                //     text2: error.response.data.error || 'An unknown error occurred',
                // });
                //console.log('ERROR IS HEREEE')
                setErrorMessage(error.response.data.error || 'An unknown error occurred');
                setIsErrorCompVisible(true)
            } else if (error.request) {
                // //console.error('No response received:', error.request);
                // Toast.show({
                //     type: 'error',
                //     text1: 'Server Error',
                //     text2: error.request,
                // });
                setErrorMessage(error.request);
                setIsErrorCompVisible(true)
            } else {
                // //console.error('Error setting up the request:', error.message);
                // Toast.show({
                //     type: 'error',
                //     text1: 'Server Error',
                //     text2: error.message,
                // });
                setErrorMessage(error.message);
                setIsErrorCompVisible(true)
            }
        }

        // finally {
        //     setIsLoading(false);
        // }
    };

    const handleValueChange = (value) => {
        // setSelectedAccount(value)
        handleAccountNumber(value)
    };

    const callACrossCheckNotice = () => {
        setNoticeMessage('Make sure the information you provide on this page is accurate. Incorrect details may affect your transactions. Please review everything carefully before clicking the Proceed button.')
        setShowCrossCheckNotice(true)
    }


    const handleProceedClicked = () => {
        if (accountNumber === '') {
            setIsFormContainerClickedA(true)
        }
        // else if (selectedBankName === '') {
        //     setIsFormContainerClickedBAN(true)
        // } 
        else if (bvn === '') {
            setIsFormContainerClickedB(true)
        } else {
            //console.log('Still Processing')
            callACrossCheckNotice()
            // verifyIdentification()
        }
    }

    const handleSelectBank = (bankName, bankCode) => {
        //console.log('bankName', bankName)
        //console.log('bankCode', bankCode)
        setSelectedBankName(bankName)
        setSelectedBankCode(bankCode)
        setShowPickerItems(false)

        //trigger resolveAccount() function

        resolveAccount(bankCode)

    }

    const selectDummyBank = () => {

        //  resolveAccount("007")

        //  getAllBanks()
    }

    const getAllBanks = async () => {
        setIsLoading1(true)
        try {
            if (accountNumber === '') {
                setIsFormContainerClickedA(true)
            } else {
                const response = await axiosPrivate.get('/getBanks')
                if (response.data && response.data.banks) {

                    setBankData(response.data.banks)
                    setShowPickerItems(true)
                }
            }

        } catch (error) {
            // Check if error response is available
            if (error.response) {
                // Server returned a response (e.g., 4xx or 5xx status)
                //console.error('Server Error:', error.response.status, error.response.data);
            } else if (error.request) {
                // No response received
                //console.error('Network Error:', error.request);
            } else {
                // Error setting up the request
                //console.error('Error:', error.message);
            }
        } finally {
            setIsLoading1(false)
        }
    }

    const resolveAccount = async (bankCode) => {
        //console.log('accountNumber', accountNumber)
        //console.log('Bank Code', bankCode)

        try {
            setIsLoading(true)
            const response = await axiosPrivate.get(`/verify/resolve-account`, {
                params: { accountNumber, bankCode },
            });
            // Check if response status is 200 and data exists
            if (response.status === 200 && response.data?.data) {
                //console.log('Resolved Account Data:', response.data.data);
                setAccount_name(response.data.data.account_name)
                setIsVisible(true); // Set visible to true if data is valid
            } else {
                //console.warn('No data returned from resolve account API');
            }
        } catch (error) {
            // //console.error('Error resolving account:', error.response?.data || error.message);
            Toast.show({
                type: 'error',
                text1: 'Error resolving account',
                text2: 'Bank name or account is incorrect',
            });
        } finally {
            setIsLoading(false)

        }
    }


    return (
        <View>


            <View style={styles.profileContainer2}>
                <View style={styles.profileHeaderContainer2}>

                    <Image source={require('../../../assets/paystack_logo.jpg')} style={styles.userImage2} />

                    {/* <Text style={{ color: Colours.DARKGRAY, fontSize: 15, marginTop: 10, fontFamily: 'Sen-Bold' }}></Text> */}
                    <Text style={{ marginTop: dynamicSpacing(15), color: Colours.PRIMARY, fontSize: dynamicFontSize(17), fontFamily: 'Sen-Medium' }}>Powered by Paystack</Text>


                    <AppTextInput
                        style={[styles.inputTxt1, isFormContainerClickedA && styles.focusedBorder,
                            //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                        ]}
                        placeholder="Enter your account no."
                        keyboardType='numeric'
                        onFocus={() => setIsFormContainerClickedA(true)}
                        onBlur={() => setIsFormContainerClickedA(false)}
                        onChangeText={handleAccountNumber}
                    />

                    <TouchableOpacity style={[styles.inputTxt, isFormContainerClickedBAN && styles.focusedBorder]}
                        // onPress={selectDummyBank}
                        onPress={getAllBanks}
                        onPressIn={() => setIsFormContainerClickedBAN(true)}
                        onPressOut={() => setIsFormContainerClickedBAN(false)}
                    >
                        {isLoading1 ? (
                            <ActivityIndicator size="small" color={Colours.PRIMARY} />
                        ) : (
                            selectedBankName ? <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>{selectedBankName}</Text>
                                : <Text style={{ color: Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>Select Bank</Text>
                        )}
                    </TouchableOpacity>
                    {isVisible && <>
                        <View style={styles.inputTxt}>
                            <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>{account_name ? account_name : "No name found"}</Text>
                        </View>

                        <View style={styles.displayTxt}>
                            <Text style={{ color: Colours.PRIMARY_LIGHT, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>ACCOUNT NAME & BVN</Text>
                        </View>

                        <AppTextInput
                            style={styles.inputTxt}
                            placeholder="First Name"
                            value={firstName}
                            onChangeText={setFirstName}
                        />

                        <AppTextInput
                            style={styles.inputTxt}
                            placeholder="Last Name"
                            value={lastName}
                            onChangeText={setLastName}
                        />

                        <AppTextInput
                            style={[styles.inputTxt, isFormContainerClickedB && styles.focusedBorder,
                                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                            ]}
                            placeholder="Enter Your BVN"
                            keyboardType='numeric'
                            onFocus={() => setIsFormContainerClickedB(true)}
                            onBlur={() => setIsFormContainerClickedB(false)}
                            onChangeText={handleBVN}
                        />

                    </>}
                    <TouchableOpacity style={styles.button2}
                        //  onPress={() => setShowVerifiedCustomer(true)}
                        onPress={handleProceedClicked}
                    >

                        {isLoading ? (
                            <ActivityIndicator size="small" color="white" />
                        ) : (
                            <Text style={{ fontSize: dynamicFontSize(15), color: 'white', fontFamily: 'Sen-Bold' }}>
                                proceed
                            </Text>
                        )}

                    </TouchableOpacity>

                </View>

                <Modal
                    AnimationType='fade'
                    visible={showPickerItems}>

                    <TopHeaderComponent headerText={'Select Bank'} hideScreen={() => setShowPickerItems(false)} />
                    <ScrollView
                        contentContainerStyle={{ flexGrow: 1, paddingBottom: dynamicSpacing(100), backgroundColor: Colours.LIGHTEST }}
                    >
                        <View style={styles.componentStyle}>

                            <BankList
                                bankData={bankData}
                                handleSelectBank={handleSelectBank} />

                        </View>
                    </ScrollView>
                </Modal>

                <Modal
                    AnimationType='fade'
                    visible={showVerifiedCustomer}
                    // onRequestClose={hideScreen}
                    onRequestClose={() => setShowVerifiedCustomer(false)}
                >
                    <TopHeaderComponent headerText={'Verification'} hideScreen={() => setShowVerifiedCustomer(false)} />
                    <ScrollView
                        contentContainerStyle={{ flexGrow: 1, paddingBottom: dynamicSpacing(100), backgroundColor: Colours.LIGHTEST }}
                    >
                        <View style={styles.componentStyle}>

                            <VerifiedCustomer
                                hideScreen={() => {
                                    setShowVerifiedCustomer(false);
                                    setShowCustomerVerificationScreen(false);
                                    hideWalletScreen();
                                }}
                                setHasDva={setHasDva}
                            />
                        </View>
                    </ScrollView>
                </Modal>

                <Modal
                    visible={isSuccessCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <SuccessAlertComp
                        message={successMessage}
                        onClose={() => {
                            setIsSuccessCompVisible(false)
                            setShowVerifiedCustomer(true)
                        }}
                    />
                </Modal>

                <Modal
                    visible={isErrorCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <ErrorAlertComp
                        message={errorMessage}
                        onClose={() => {
                            setIsErrorCompVisible(false)

                        }}
                    />
                </Modal>

                <Modal
                    visible={crossCheckNotice}
                    transparent={true}
                    animationType="fade"
                    onRequestClose={() => setShowCrossCheckNotice(false)}
                >
                    <NoticeAlertComp
                        message={noticeMessage}
                        isLoading={isLoading}
                        onCancel={() => setShowCrossCheckNotice(false)}
                        onClose={() => {
                            verifyIdentification()
                            setShowCrossCheckNotice(false)
                        }}
                    // onClose={() => {setShowCustomerVerificationScreen(true)}}
                    />
                </Modal>


            </View>
            <Toast config={toastConfig} />
        </View>
    )
}

const styles = StyleSheet.create({

    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        height: '100%',

    },

    profileContainer2: {
        padding: dynamicSpacing(30),
    },
    profileHeaderContainer2: {
        display: 'flex',
        // flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        // paddingTop: 30 ,
        //  height: '80%',
        // backgroundColor: Colours.LIGHTGRAY
        // gap: 10,
    },
    userImage2: {
        width: dynamicSize(100),
        height: dynamicSize(100),
        borderWidth: 2,
        borderColor: 'white',
        borderRadius: dynamicSize(99),
    },
    button2: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(20),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.PRIMARY,
    },

    focusedBorder: {
        borderColor: Colours.PRIMARY,
        borderWidth: 2
    },

    inputTxt1: {
        height: dynamicSize(40),
        width: '100%',
        marginTop: dynamicSpacing(25),
        // gap: 10,
        padding: dynamicSpacing(10),
        borderWidth: 2.5,
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        // marginBottom: 10,
        // marginRight: 10,
    },

    inputTxt: {
        height: dynamicSize(40),
        width: '100%',
        marginTop: dynamicSpacing(10),
        // gap: 10,
        padding: dynamicSpacing(10),
        borderWidth: 2.5,
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        // marginBottom: 10,
        // marginRight: 10,
    },
    displayTxt: {
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        height: dynamicSize(40),
        width: '100%',
        marginTop: dynamicSpacing(10),
        // gap: 10,
        padding: dynamicSpacing(10),
        borderWidth: 2.5,
        borderColor: Colours.PRIMARY_LIGHT,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        // backgroundColor: Colours.LIGHTGRAY,
        // marginBottom: 10,
        // marginRight: 10,
    },
    picker: {
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(13),
    },
    itemStyle: {
        fontSize: dynamicFontSize(13),
    },
    pickerModal: {
        // margin: 20,
        display: 'flex',
        padding: dynamicSpacing(20),
        backgroundColor: Colours.PRIMARY_LIGHTER,
        // bottom: 30,
        // left: 30,
        // right: 30,
        // position: 'absolute',
        // borderRadius: 10,
        // maxHeight: 170,
    },
    scrollViewContent: {
        paddingBottom: dynamicSpacing(20)
    },
    separator: {
        height: 1,
        backgroundColor: Colours.DARKGRAY,
        marginTop: dynamicSpacing(10),
    },

})

export default CustomerVerificationScreen
